import { BadgeCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Tiny inline badge that sits next to a supplier's name on listings/storefronts.
 *
 * Shown for any seller PatinaMart has manually verified — i.e. real businesses
 * we've eyeballed. NOT shown for external aggregator listings (Gumtree / FB /
 * Craigslist imports) — those carry the source pill instead, which is honest
 * about the fact that we haven't verified the underlying seller.
 *
 * Clicking jumps to the public /trust page that explains the verification
 * criteria so sceptical buyers can understand what the badge actually means.
 */
export default function VerifiedSellerBadge({ size = 'sm', className = '' }) {
  const dim = size === 'lg' ? 'w-4 h-4' : 'w-3 h-3';
  return (
    <Link
      to="/trust"
      className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-accent/10 text-accent border border-accent/30 font-medium whitespace-nowrap hover:bg-accent/20 transition-colors ${className}`}
      title="PatinaMart has manually verified this seller — click for details"
      data-testid="verified-seller-badge"
      onClick={(e) => e.stopPropagation()}
    >
      <BadgeCheck className={dim} />
      Verified seller
    </Link>
  );
}
